module.exports = __webpack_public_path__ + "static/media/correctivo_rojo.4779fdd3.svg";